$(document).ready(function () {

    $('.dropify').dropify();

    $("#requests-table").dataTable({
        'processing': true,
        'serverSide': true,
        'ajax': 'get-request-by-user/',
        'columns': [
            {data: 'order'},
            {data: 'user_request.name'},
            {data: 'name'},
            {data: 'problem'},
            {data: 'get_state_for_request.description'},
            {data: 'user_assigned.name'},
            {data: 'date'},
        ],
        order: [[1,'desc']],
        "columnDefs": [
            {
                "targets": 7,
                "render": function (data, type, row, meta) {
                    return "<button type='button' target='_blank'" +
                        "class='btn btn-corporativo btn-sm view_detail' " +
                        "data-uuid='" + row.uuid + "' >" +
                        "<i class='fa-solid fa-list'></i>" +
                        "</button> "
                        + btn_request_cancel(row)
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    })

    $("#add-request").on('click', function () {
        $("#modal-request").modal('show')
        clearSpanError()
        $("#form-create-request")[0].reset()
        $(".item-branch_id").val('').trigger('chosen:updated')
        $(".modal-my-request-title").html('Crear solicitud')
    })

    $("#form-create-request").on('submit', function (e) {
        e.preventDefault()
        let data = new FormData(this)
        sendData(data, 'create-request')
    })

    $("#requests-table tbody").on('click', '.view_detail', function (){
        let uuid = $(this).data('uuid')
        let pathname = $(location).attr('origin');
        window.location.href = pathname + "/soporte/detalle/ticket-uuid/" + uuid;
    })

    $("#requests-table tbody").on('click','.request_cancel', function (e){
        e.preventDefault()
        Swal.fire({
            title: "Ingresa el motivo de la cancelación ",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                required: 'true'
            },
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Enviar",
            showLoaderOnConfirm: true,
            preConfirm: async (text) => {
                let data = new FormData();
                let uuid = $(this).data('uuid')
                data.append('text',text)
                data.append('uuid',uuid)
                try {
                    $.LoadingOverlay("show");
                    $.ajax({
                            url: 'cancel-request',
                            type: 'POST',
                            data: data,
                            processData: false,
                            contentType: false,
                            headers: {
                                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                            },
                            success: function (response) {
                                setTimeout(function () {
                                    $.LoadingOverlay("hide");
                                    alertSuccess(response.msg)
                                    $("#requests-table").DataTable().ajax.reload()
                                }, 1000)
                            }
                    });

                } catch (error) {
                    // Manejo de errores si es necesario
                    Swal.showValidationMessage(`
        Request failed: ${error}
      `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            /*if (result.isConfirmed) {
                Swal.fire({
                    title: "Resultado",
                    text: result.value.result
                });
            }*/
        });
    })

    $("#finish_ticket").on('click', function (e){
        e.preventDefault()
        Swal.fire({
            text: "¿ Estas seguro de finalizar esta solicitud ? ",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!'
        }).then((result) => {
            if (result.isConfirmed) {
                $("#calificacionModal").modal('show')
            }
        })
    })

    $("#form-rate-service").on('submit', function (e){
        e.preventDefault()
        let data = new FormData(this)
        sendData(data,'/soporte/detalle/ticket-uuid/finalize-request')
        $("#calificacionModal").modal('hide')
    })

    $("#form-time-line").on('submit', function (e){
        e.preventDefault()
        let data = new FormData()
        const file = document.getElementById('item-file').files[0];
        let route = "../add-detail-to-ticket"
        let uuid = $("#item-uuid").val();
        data.append('uuid', uuid);
        data.append('comment_timeline', $("#comment_timeline").val());
        data.append('file', file)
        sendData(data,route)
    })

    function sendData(data, route) {
        $.LoadingOverlay("show", window.loadingOverlayOptions);
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (response) {
                setTimeout(function () {
                    $.LoadingOverlay("hide");
                    if (response.type == "view") {
                        document.getElementById('div_timeline').innerHTML = response.view;
                        alertSuccess(response.msg)
                        $("#item-file").val('')
                        $("#comment_timeline").val('')
                    }else if (response.type == "success") {
                        $("#modal-request").modal('hide')
                        alertSuccess(response.msg)
                        $("#requests-table").DataTable().ajax.reload()
                    } else {
                        alertError(response.msg)
                    }
                }, 1000)

            }, error: function (errors, xhr, status,) {
                $("#modal-request").modal('hide')
                $.LoadingOverlay("hide");
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-error-" + index).html(value)
                });
            }
        });
    }

    function btn_request_cancel(row)
    {
        if (row.get_state_for_request.description == "Nuevo") {
            return "<button type='button' " +
                "class='btn btn-danger btn-sm request_cancel' " +
                "data-uuid='" + row.uuid + "' >" +
                "<i class='fa-solid fa-trash-can'></i>" +
                "</button> ";
        }else{
            return "";
        }

    }


    function clearSpanError()
    {
        $(".item-error-file").html('')
    }

})
